import { createIcon } from '@chakra-ui/icons'

const WEBMIcon = createIcon({
  viewBox: '0 0 77.9 86.9',
  path: (
    <>
      <path
        d="M68.5 83.5h-59C7 83.5 5 81.5 5 79V8c0-2.5 2-4.5 4.5-4.5h44.4L73 20.7V79c0 2.4-2.1 4.5-4.5 4.5z"
        fill="#FFFFFF"
      />
      <path
        d="M68.5 83c2.2 0 4-1.8 4-4V21L53.6 4H9.5c-2.2 0-4 1.8-4 4v71c0 2.2 1.8 4 4 4h59m0 1h-59c-2.8 0-5-2.2-5-5V8c0-2.8 2.2-5 5-5H54l19.4 17.6V79c.1 2.7-2.2 5-4.9 5z"
        fill="#E1E4EA"
      />
      <path
        d="M73.5 33h-69V8c0-2.8 2.2-5 5-5H55l18.4 17.5V33z"
        fill="#559469"
      />
      <path
        d="M55.2 3v9.9s-.4 7.4 7.8 7.5 10.4 0 10.4 0L55.2 3z"
        opacity=".6"
        fill="#FFFFFF"
      />
      <text
        transform="translate(11.467 21.968)"
        fontSize="12"
        fontFamily="ArialMT"
        fill="#F7FAFC"
      >
        WEBM
      </text>
      <path
        d="M49.1 71.8h6.8c.3 0 .6-.3.6-.6V45.8c0-.3-.3-.6-.6-.6H22.1c-.3 0-.6.3-.6.6v25.3c0 .3.3.6.6.6h27zm6.1-19.9h-5.5v-5.1h5.5v5.1zm0 6.4h-5.5v-5.1h5.5v5.1zm-5.5 1.2h5.5v4.6h-5.5v-4.6zm-1.2-6.9v5.7h-19V46.4h19v6.2zm-25.8 5.7v-5.1h5.5v5.1h-5.5zm0-11.4h5.5V52h-5.5v-5.1zm0 12.6h5.5v4.6h-5.5v-4.6zm6.8 5.3v-5.3h19v11h-19v-5.7zm25.7 5.7h-5.5v-5.1h5.5v5.1zm-32.5 0v-5.1h5.5v5.1h-5.5z"
        fill="#E1E4EB"
      />
    </>
  ),
})

export default WEBMIcon
